import { Event } from '@/app/event-stream';

export const SectionOpenedEventName = 'section-opened' as const;
export interface SectionOpenedEvent {
  sectionId: string;
  title: string;
}

export const SectionClosedEventName = 'section-closed' as const;
export interface SectionClosedEvent {
  sectionId: string;
  title: string;
  durationSeconds: number;
}

export const navigationEventNames = [
  SectionOpenedEventName,
  SectionClosedEventName
];

export type NavigationEvent =
      Event<typeof SectionOpenedEventName, SectionOpenedEvent> |
      Event<typeof SectionClosedEventName, SectionClosedEvent>;
